import { render, staticRenderFns } from "./SelectPrintersNew.vue?vue&type=template&id=4c5dd8a2&scoped=true&"
import script from "./SelectPrintersNew.vue?vue&type=script&lang=js&"
export * from "./SelectPrintersNew.vue?vue&type=script&lang=js&"
import style0 from "./SelectPrintersNew.vue?vue&type=style&index=0&id=4c5dd8a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5dd8a2",
  null
  
)

export default component.exports